import * as o from "react";
import s from "../lib/IconBase.es.js";
import a from "../defs/ArrowsLeftRight.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(s, { ref: e, ...t, weights: a }));
r.displayName = "ArrowsLeftRightIcon";
const m = r;
export {
  m as ArrowsLeftRight,
  r as ArrowsLeftRightIcon
};
